import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import { Button } from 'reactstrap'

import AUX from '../../hoc/Aux_'
import { userActions } from '../../_actions'


export class Login extends Component {

    constructor(props) {
        super(props)
        this.props.dispatch(userActions.logout());
    }

    state = {
        username: "",
        password: "",
        remember_me: true,
        submitted: false,
    }

    handleChange = e => {
        const { name, value } = e.target
        this.setState({ [name]: value })
    }

    handleSubmit = e => {
        e.preventDefault()

        this.setState({ submitted: true })
        const { username, password, remember_me } = this.state
        var formData = new FormData()
        formData.append('username', username)
        formData.append('password', password)
        formData.append('remember_me', remember_me)
        const { dispatch } = this.props
        if (username && password) {
            dispatch(userActions.login(formData))
        }
    }

    render() {
        const { username, password, remember_me, submitted } = this.state
        const { alert } = this.props

        return (
            <AUX>
                <div className="accountbg"></div>
                <div className="wrapper-page">
                    <div className="card">
                        <div className="card-body">

                            <h3 className="text-center">
                                <Link to="/" className="logo logo-admin"><img src="/assets/images/emkode.png" height="100" alt="logo" /></Link>
                            </h3>

                            <div>

                                {alert && alert.type &&
                                    <div className={`alert ${alert.type}`} role="alert">
                                        {alert.message.map((item, key) => <li key>{item.message}</li>)}
                                    </div>
                                }

                                <form className={"form-horizontal m-t-30 needs-validation" + (submitted ? " was-validated" : "")} onSubmit={this.handleSubmit} noValidate>

                                    <div className="form-group">
                                        <label htmlFor="username">Nombre de usuario</label>
                                        <input value={username} onChange={this.handleChange} type="text" className="form-control" name="username" id="username" placeholder="Enter username" required />
                                        <div className="invalid-feedback">Nombre de usuario.</div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="password">Password</label>
                                        <input value={password} onChange={this.handleChange} type="password" className="form-control" name="password" id="password" placeholder="Enter password" required />
                                        <div className="invalid-feedback">El password es requerido.</div>
                                    </div>

                                    <div className="form-group row m-t-20">
                                        <div className="col-sm-6">
                                            <div className="custom-control custom-checkbox">
                                                <input defaultChecked={remember_me} type="checkbox" className="custom-control-input" id="remember_me" />
                                                <label className="custom-control-label" htmlFor="remember_me">Recordarme</label>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 text-right">
                                            <Button disabled={submitted && alert} className="btn btn-primary w-md waves-effect waves-light" type="submit">
                                                Entrar
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </AUX>
        )
    }
}

const mapStatetoProps = state => {
    const { alert } = state
    const { loggingIn } = state.authentication
    return {
        loggingIn,
        alert
    }
}

Login = connect(mapStatetoProps)(Login)